<div class="container">
  <div class="element-card" *ngFor="let element of data.elements">
    <div class="element-header">
      <a
        class="element-name"
        [routerLink]="['/details', data.therapeuticArea.id, element.link]"
        >{{ element.elementName }}</a
      >
      <span class="flag {{ element.colorName }}"></span>
    </div>

    <p class="element-description">
      {{ element.description }}
    </p>
  </div>
</div>
